module.exports = __webpack_public_path__ + "static/signature-70dec2eac7b5ff56e34bc05aaadcc6d1.png";